import React from "react";

const RowsPerPage = ({ value, onChange, options = [10, 50, 100] }) => {
  return (
    <div className="col-md-6">
      <div className="rowsperpage page-title p-2">
        <p className="d-flex align-items-center">
          Rows per page:
          <select
            className="searchForRows ms-2 me-2"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          >
            {options.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
          entries
        </p>
      </div>
    </div>
  );
};

export default RowsPerPage;
